import React from 'react';
import MenuPaintedButton from './MenuPaintedButton';
import {
  AFTER_BATTLE_BLUE_BUTTON_PATH,
  AFTER_BATTLE_GOLDEN_BUTTON_PATH,
  AFTER_BATTLE_GOLDEN_BUTTON_SURFACE_FILTER,
  AFTER_BATTLE_GREEN_BUTTON_PATH,
  AFTER_BATTLE_WHITE_BUTTON_PATH,
} from '../config/welcomeAssets';

const AFTER_BATTLE_BUTTON_VARIANTS = {
  golden: {
    imagePath: AFTER_BATTLE_GOLDEN_BUTTON_PATH,
    surfaceFilter: AFTER_BATTLE_GOLDEN_BUTTON_SURFACE_FILTER,
    className: 'afterbattle-button--golden',
  },
  white: {
    imagePath: AFTER_BATTLE_WHITE_BUTTON_PATH,
    className: 'afterbattle-button--white',
  },
  blue: {
    imagePath: AFTER_BATTLE_BLUE_BUTTON_PATH,
    className: 'afterbattle-button--blue',
  },
  green: {
    imagePath: AFTER_BATTLE_GREEN_BUTTON_PATH,
    className: 'afterbattle-button--green',
  },
};

export default function AfterBattleButton({
  variant = 'white',
  className = '',
  style,
  ...rest
}) {
  const config = AFTER_BATTLE_BUTTON_VARIANTS[variant];
  if (!config) {
    throw new Error(`AfterBattleButton: unknown variant "${variant}"`);
  }

  return (
    <MenuPaintedButton
      className={`afterbattle-button ${config.className} ${className}`.trim()}
      imagePath={config.imagePath}
      surfaceFilter={config.surfaceFilter}
      style={style}
      {...rest}
    />
  );
}
